<template>
    <div :class="`as-goals-scored`">
        <div class="as-goals-scored__head">
            <IconCorner/>
            <span> Tổng số phạt góc  </span>
        </div>
        <div class="as-history">
            <div class="as-history-item">
                <div class="as-history-item__head">
                    <div class="as-head-tab" :class="{ 'as-active': activeTab === 'all' }" @click="setActiveTab('all')">
                        Cả trận
                    </div>
                    <div class="as-head-tab" :class="{ 'as-active': activeTab === 'half' }" @click="setActiveTab('half')">
                        Hiệp 1/2
                    </div>
                </div>
                <div class="as-history-item__body">
                    <div class="as-competition" v-if="activeTab === 'all'">
                        <table class="as-competition__table">
                            <thead>
                                <tr>
                                    <th>Số quả PG</th>
                                    <th class="as-center a">{{ footyStats?.home_name }}</th>
                                    <th class="as-center a">{{ footyStats?.away_name }}</th>
                                    <th class="as-center a">Trung bình</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Trên 6.5</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', 'over65CornersPercentage_overall'))}`">
                                        {{ getValueWithMode('home', 'over65CornersPercentage_overall') }}%</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('away', 'over65CornersPercentage_overall'))}`">
                                        {{ getValueWithMode('away', 'over65CornersPercentage_overall') }}%</td>
                                    <td :class="`as-center ${getClassForItem(calculatorAVG(getValueWithMode('home', 'over65CornersPercentage_overall'), getValueWithMode('away', 'over65CornersPercentage_overall')))}`">
                                        {{ calculatorAVG(getValueWithMode('home', 'over65CornersPercentage_overall'), getValueWithMode('away', 'over65CornersPercentage_overall')) }}%
                                    </td>
                                </tr>
                                <tr>
                                    <td>Trên 7.5</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', 'over75CornersPercentage_overall'))}`">
                                        {{ getValueWithMode('home', 'over75CornersPercentage_overall') }}%
                                    </td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('away', 'over75CornersPercentage_overall'))}`">
                                        {{ getValueWithMode('away', 'over75CornersPercentage_overall') }}%
                                    </td>
                                    <td :class="`as-center ${getClassForItem(calculatorAVG(getValueWithMode('home', 'over75CornersPercentage_overall'), getValueWithMode('away', 'over75CornersPercentage_overall')))}`">
                                        {{ calculatorAVG(getValueWithMode('home', 'over75CornersPercentage_overall'), getValueWithMode('away', 'over75CornersPercentage_overall')) }}%
                                    </td>
                                </tr>
                                <tr>
                                    <td>Trên 8.5</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', 'over85CornersPercentage_overall'))}`">
                                        {{ getValueWithMode('home', 'over85CornersPercentage_overall') }}%
                                    </td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('away', 'over85CornersPercentage_overall'))}`">
                                        {{ getValueWithMode('away', 'over85CornersPercentage_overall') }}%
                                    </td>
                                    <td :class="`as-center ${getClassForItem(calculatorAVG(getValueWithMode('home', 'over85CornersPercentage_overall'), getValueWithMode('away', 'over85CornersPercentage_overall')))}`">
                                        {{ calculatorAVG(getValueWithMode('home', 'over85CornersPercentage_overall'), getValueWithMode('away', 'over85CornersPercentage_overall')) }}%
                                    </td>
                                </tr>
                                <tr>
                                    <td>Trên 9.5</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', 'over95CornersPercentage_overall'))}`">
                                        {{ getValueWithMode('home', 'over95CornersPercentage_overall') }}%
                                    </td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('away', 'over95CornersPercentage_overall'))}`">
                                        {{ getValueWithMode('away', 'over95CornersPercentage_overall') }}%
                                    </td>
                                    <td :class="`as-center ${getClassForItem(calculatorAVG(getValueWithMode('home', 'over95CornersPercentage_overall'), getValueWithMode('away', 'over95CornersPercentage_overall')))}`">
                                        {{ calculatorAVG(getValueWithMode('home', 'over95CornersPercentage_overall'), getValueWithMode('away', 'over95CornersPercentage_overall')) }}%
                                    </td>
                                </tr>
                                <tr>
                                    <td>Trên 10.5</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', 'over105CornersPercentage_overall'))}`">
                                        {{ getValueWithMode('home', 'over105CornersPercentage_overall') }}%
                                    </td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('away', 'over105CornersPercentage_overall'))}`">
                                        {{ getValueWithMode('away', 'over105CornersPercentage_overall') }}%
                                    </td>
                                    <td :class="`as-center ${getClassForItem(calculatorAVG(getValueWithMode('home', 'over105CornersPercentage_overall'), getValueWithMode('away', 'over105CornersPercentage_overall')))}`">
                                        {{ calculatorAVG(getValueWithMode('home', 'over105CornersPercentage_overall'), getValueWithMode('away', 'over105CornersPercentage_overall')) }}%
                                    </td>
                                </tr>
                                <tr>
                                    <td>Trên 11.5</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', 'over115CornersPercentage_overall'))}`">
                                        {{ getValueWithMode('home', 'over115CornersPercentage_overall') }}%
                                    </td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('away', 'over115CornersPercentage_overall'))}`">
                                        {{ getValueWithMode('away', 'over115CornersPercentage_overall') }}%
                                    </td>
                                    <td :class="`as-center ${getClassForItem(calculatorAVG(getValueWithMode('home', 'over115CornersPercentage_overall'), getValueWithMode('away', 'over115CornersPercentage_overall')))}`">
                                        {{ calculatorAVG(getValueWithMode('home', 'over115CornersPercentage_overall'), getValueWithMode('away', 'over115CornersPercentage_overall')) }}%
                                    </td>
                                </tr>
                                <tr>
                                    <td>Trên 12.5</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', 'over125CornersPercentage_overall'))}`">
                                        {{ getValueWithMode('home', 'over125CornersPercentage_overall') }}%
                                    </td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('away', 'over125CornersPercentage_overall'))}`">
                                        {{ getValueWithMode('away', 'over125CornersPercentage_overall') }}%
                                    </td>
                                    <td :class="`as-center ${getClassForItem(calculatorAVG(getValueWithMode('home', 'over125CornersPercentage_overall'), getValueWithMode('away', 'over125CornersPercentage_overall')))}`">
                                        {{ calculatorAVG(getValueWithMode('home', 'over125CornersPercentage_overall'), getValueWithMode('away', 'over125CornersPercentage_overall')) }}%
                                    </td>
                                </tr>
                                <tr>
                                    <td>Trên 13.5</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', 'over135CornersPercentage_overall'))}`">
                                        {{ getValueWithMode('home', 'over135CornersPercentage_overall') }}%
                                    </td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('away', 'over135CornersPercentage_overall'))}`">
                                        {{ getValueWithMode('away', 'over135CornersPercentage_overall') }}%
                                    </td>
                                    <td :class="`as-center ${getClassForItem(calculatorAVG(getValueWithMode('home', 'over135CornersPercentage_overall'), getValueWithMode('away', 'over135CornersPercentage_overall')))}`">
                                        {{ calculatorAVG(getValueWithMode('home', 'over135CornersPercentage_overall'), getValueWithMode('away', 'over135CornersPercentage_overall')) }}%
                                    </td>
                                </tr>
                                <tr>
                                    <td>Trên 14.5</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', 'over145CornersPercentage_overall'))}`">
                                        {{ getValueWithMode('home', 'over145CornersPercentage_overall') }}%
                                    </td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('away', 'over145CornersPercentage_overall'))}`">
                                        {{ getValueWithMode('away', 'over145CornersPercentage_overall') }}%
                                    </td>
                                    <td :class="`as-center ${getClassForItem(calculatorAVG(getValueWithMode('home', 'over145CornersPercentage_overall'), getValueWithMode('away', 'over145CornersPercentage_overall')))}`">
                                        {{ calculatorAVG(getValueWithMode('home', 'over145CornersPercentage_overall'), getValueWithMode('away', 'over145CornersPercentage_overall')) }}%
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="as-competition" v-if="activeTab === 'half'">
                        <table class="as-competition__table">
                            <thead>
                                <tr>
                                    <th>First Half</th>
                                    <th class="as-center a">{{ footyStats?.home_name }}</th>
                                    <th class="as-center a">{{ footyStats?.away_name }}</th>
                                    <th class="as-center a">Trung bình</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>FH Average</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', 'corners_fh_avg_overall'))}`">
                                        {{ getValueWithMode('home', 'corners_fh_avg_overall') }}
                                    </td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('away', 'corners_fh_avg_overall'))}`">
                                        {{ getValueWithMode('away', 'corners_fh_avg_overall') }}
                                    </td>
                                    <td :class="`as-center ${getClassForItem(calculatorAVG(getValueWithMode('home', 'corners_fh_avg_overall'), getValueWithMode('away', 'corners_fh_avg_overall')))}`">
                                        {{ calculatorAVG(getValueWithMode('home', 'corners_fh_avg_overall'), getValueWithMode('away', 'corners_fh_avg_overall')) }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>FH Over 4</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', 'corners_fh_over4_percentage_overall'))}`">
                                        {{ getValueWithMode('home', 'corners_fh_over4_percentage_overall') }}%
                                    </td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('away', 'corners_fh_over4_percentage_overall'))}`">
                                        {{ getValueWithMode('away', 'corners_fh_over4_percentage_overall') }}%
                                    </td>
                                    <td :class="`as-center ${getClassForItem(calculatorAVG(getValueWithMode('home', 'corners_fh_over4_percentage_overall'), getValueWithMode('away', 'corners_fh_over4_percentage_overall')))}`">
                                        {{ calculatorAVG(getValueWithMode('home', 'corners_fh_over4_percentage_overall'), getValueWithMode('away', 'corners_fh_over4_percentage_overall')) }}%
                                    </td>
                                </tr>
                                <tr>
                                    <td>FH Over 5</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', 'corners_fh_over5_percentage_overall'))}`">
                                        {{ getValueWithMode('home', 'corners_fh_over5_percentage_overall') }}%
                                    </td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('away', 'corners_fh_over5_percentage_overall'))}`">
                                        {{ getValueWithMode('away', 'corners_fh_over5_percentage_overall') }}%
                                    </td>
                                    <td :class="`as-center ${getClassForItem(calculatorAVG(getValueWithMode('home', 'corners_fh_over5_percentage_overall'), getValueWithMode('away', 'corners_fh_over5_percentage_overall')))}`">
                                        {{ calculatorAVG(getValueWithMode('home', 'corners_fh_over5_percentage_overall'), getValueWithMode('away', 'corners_fh_over5_percentage_overall')) }}%
                                    </td>
                                </tr>
                                <tr>
                                    <td>FH Over 6</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', 'corners_fh_over6_percentage_overall'))}`">
                                        {{ getValueWithMode('home', 'corners_fh_over6_percentage_overall') }}%
                                    </td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('away', 'corners_fh_over6_percentage_overall'))}`">
                                        {{ getValueWithMode('away', 'corners_fh_over6_percentage_overall') }}%
                                    </td>
                                    <td :class="`as-center ${getClassForItem(calculatorAVG(getValueWithMode('home', 'corners_fh_over6_percentage_overall'), getValueWithMode('away', 'corners_fh_over6_percentage_overall')))}`">
                                        {{ calculatorAVG(getValueWithMode('home', 'corners_fh_over6_percentage_overall'), getValueWithMode('away', 'corners_fh_over6_percentage_overall')) }}%
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <br/>
                        <table class="as-competition__table">
                            <thead>
                                <tr>
                                    <th>Second Half</th>
                                    <th class="as-center a">{{ footyStats?.home_name }}</th>
                                    <th class="as-center a">{{ footyStats?.away_name }}</th>
                                    <th class="as-center a">Trung bình</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>2H Average</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', 'corners_2h_avg_overall'))}`">
                                        {{ getValueWithMode('home', 'corners_2h_avg_overall') }}
                                    </td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('away', 'corners_2h_avg_overall'))}`">
                                        {{ getValueWithMode('away', 'corners_2h_avg_overall') }}
                                    </td>
                                    <td :class="`as-center ${getClassForItem(calculatorAVG(getValueWithMode('home', 'corners_2h_avg_overall'), getValueWithMode('away', 'corners_2h_avg_overall')))}`">
                                        {{ calculatorAVG(getValueWithMode('home', 'corners_2h_avg_overall'), getValueWithMode('away', 'corners_2h_avg_overall')) }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>FH Over 4</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', 'corners_2h_over4_percentage_overall'))}`">
                                        {{ getValueWithMode('home', 'corners_2h_over4_percentage_overall') }}%
                                    </td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('away', 'corners_2h_over4_percentage_overall'))}`">
                                        {{ getValueWithMode('away', 'corners_2h_over4_percentage_overall') }}%
                                    </td>
                                    <td :class="`as-center ${getClassForItem(calculatorAVG(getValueWithMode('home', 'corners_2h_over4_percentage_overall'), getValueWithMode('away', 'corners_2h_over4_percentage_overall')))}`">
                                        {{ calculatorAVG(getValueWithMode('home', 'corners_2h_over4_percentage_overall'), getValueWithMode('away', 'corners_2h_over4_percentage_overall')) }}%
                                    </td>
                                </tr>
                                <tr>
                                    <td>FH Over 5</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', 'corners_2h_over5_percentage_overall'))}`">
                                        {{ getValueWithMode('home', 'corners_2h_over5_percentage_overall') }}%
                                    </td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('away', 'corners_2h_over5_percentage_overall'))}`">
                                        {{ getValueWithMode('away', 'corners_2h_over5_percentage_overall') }}%
                                    </td>
                                    <td :class="`as-center ${getClassForItem(calculatorAVG(getValueWithMode('home', 'corners_2h_over5_percentage_overall'), getValueWithMode('away', 'corners_2h_over5_percentage_overall')))}`">
                                        {{ calculatorAVG(getValueWithMode('home', 'corners_2h_over5_percentage_overall'), getValueWithMode('away', 'corners_2h_over5_percentage_overall')) }}%
                                    </td>
                                </tr>
                                <tr>
                                    <td>FH Over 6</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', 'corners_2h_over6_percentage_overall'))}`">
                                        {{ getValueWithMode('home', 'corners_2h_over6_percentage_overall') }}%
                                    </td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('away', 'corners_2h_over6_percentage_overall'))}`">
                                        {{ getValueWithMode('away', 'corners_2h_over6_percentage_overall') }}%
                                    </td>
                                    <td :class="`as-center ${getClassForItem(calculatorAVG(getValueWithMode('home', 'corners_2h_over6_percentage_overall'), getValueWithMode('away', 'corners_2h_over6_percentage_overall')))}`">
                                        {{ calculatorAVG(getValueWithMode('home', 'corners_2h_over6_percentage_overall'), getValueWithMode('away', 'corners_2h_over6_percentage_overall')) }}%
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
    import IconCorner from '~src/components/icons/foot_stats/IconCorner.vue';
    import type { IMatch } from '~src/interfaces';
    import type { IFootyStats, ITeam, IStatsParent } from '~src/interfaces/footystats';
    import { ref, computed } from 'vue';
    import { getClassForItem } from '~src/helpers/footystats';

    interface Props{
        match: IMatch;
        mode?: string;
        footyStats: IFootyStats | null;
        homeTeamInfo: ITeam | null;
        awayTeamInfo: ITeam | null;
    }

    const props = withDefaults(defineProps<Props>(),{
        mode: 'as-win'
    })

    const activeTab = ref('all')
    const setActiveTab = (tab: string) => {
        activeTab.value = tab;
    };

    const homeTeamLastX = computed<IStatsParent>(() => {
        return props.footyStats?.home_team_last_x ?? ({} as IStatsParent);
    });

    const awayTeamLastX = computed<IStatsParent>(() => {
        return props.footyStats?.away_team_last_x ?? ({} as IStatsParent);
    });

    const getValueWithMode = (team = 'home', mode = 'btts', mode_half = '') => {
        const __data: IStatsParent = team === 'home' ? homeTeamLastX.value : awayTeamLastX.value;

        let __mode = mode
        if(mode_half){
            __mode = mode_half
        }
        if (!__data || !__data.stats || !__data.stats.hasOwnProperty(__mode)) {
            return 0;
        }

        return __data.stats[__mode] as number;
    }

    const calculatorAVG = (home: number, away: number) => {
        const _avg = (home + away) / 2

        return Math.round(_avg)
    }

</script>

<script lang="ts">
export default {};
</script>
